import React from "react";
import "./HeroSlider.scss";

import health from "../../../assets/HeroCarouselImage/health-insurance.png";
import motor from "../../../assets/HeroCarouselImage/car-insurance.png";
import marine from "../../../assets/HeroCarouselImage/marine-insurance.png";
import misc from "../../../assets/HeroCarouselImage/misc-insurance.png";
import property from "../../../assets/HeroCarouselImage/property-insurance.png";
// import engine from "../../../assets/HeroCarouselImage/engineering-insurance.png";
import { Link } from "react-router-dom";

const HeroSlider = () => {
  return (
    <>
      {/* hero carousel new with fade in */}
      <div className="heroSlider">
        <div
          id="carouselExampleCaptions"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
          data-bs-pause="false"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="4"
              aria-label="Slide 5"
            ></button>
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <div
                className="image_layer"
                style={{ backgroundImage: `url(${motor})` }}
              ></div>

              {/* <img src="..." className="d-block w-100" alt="..." /> */}

              <div className="container">
                <div className="carousel-caption">
                  <div className="carousel_inner_content">
                    <div className="line animated bounceInLeft"></div>

                    <h1>
                      Reliable Insurance <br /> for Any Purpose
                    </h1>
                    <p>We'll help protect the things that matter</p>

                    {/* <div className="">
                      <Link to="" className="btn main_btn">
                        Learn More
                      </Link>
                    </div> */}
                    <Link to="motor-insurance" className="btn main_btn">
                      <span className="btn_text">Learn More</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div
                className="image_layer"
                style={{ backgroundImage: `url(${marine})` }}
              ></div>

              <div className="container">
                <div className="carousel-caption">
                  <div className="carousel_inner_content">
                    <div className="line animated bounceInLeft"></div>

                    <h1>
                      Reliable Insurance <br /> for Any Purpose
                    </h1>
                    {/* <p>
                      Lorem ipsum dolor sit amet, consectetur <br /> adipiscing
                      elit, sed do eiusmod tempor incididunt <br /> ut labore et
                      dolore magna aliqua
                    </p> */}
                    <p>We'll help protect the things that matter</p>

                    <Link to="/marine-insurance" className="btn main_btn">
                      <span className="btn_text">Learn More</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div
                className="image_layer"
                style={{ backgroundImage: `url(${health})` }}
              ></div>

              <div className="container">
                <div className="carousel-caption">
                  <div className="carousel_inner_content">
                    <div className="line animated bounceInLeft"></div>

                    <h1>
                      Reliable Insurance <br /> for Any Purpose
                    </h1>
                    {/* <p>
                      Lorem ipsum dolor sit amet, consectetur <br /> adipiscing
                      elit, sed do eiusmod tempor incididunt <br /> ut labore et
                      dolore magna aliqua
                    </p> */}
                    <p>We'll help protect the things that matter</p>

                    <Link to="miscellaneous-insurance" className="btn main_btn">
                      <span className="btn_text">Learn More</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div
                className="image_layer"
                style={{ backgroundImage: `url(${property})` }}
              ></div>

              <div className="container">
                <div className="carousel-caption">
                  <div className="carousel_inner_content">
                    <div className="line animated bounceInLeft"></div>

                    <h1>
                      Reliable Insurance <br /> for Any Purpose
                    </h1>

                    <p>We'll help protect the things that matter</p>

                    <Link to="property-insurance" className="btn main_btn">
                      <span className="btn_text">Learn More</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="carousel-item">
              <div
                className="image_layer"
                style={{ backgroundImage: `url(${misc})` }}
              ></div>

              <div className="container">
                <div className="carousel-caption">
                  <div className="carousel_inner_content">
                    <div className="line animated bounceInLeft"></div>

                    <h1>
                      Reliable Insurance <br /> for Any Purpose
                    </h1>
                    <p>We'll help protect the things that matter</p>

                    <Link to="engineering-insurance" className="btn main_btn">
                      <span className="btn_text">
                        <span className="btn_text">Learn More</span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      {/* !hero carousel new with fade in */}
    </>
  );
};

export default HeroSlider;
